export default {
  archive: {
    fetching: false,
    fetched: false,
    data: null
  }
}
